import Component from '../core/Component'
import EventBus from '../core/EventBus'

export const STATES = {
    ACTIVE: 'is-active',
    MENU_OPEN: 'is-menu-open'
}

export default class NavLogoLink extends Component {
    constructor(element) {
        super(element)
    }
    prepare() {
        this.element.addEventListener('click', :: this.handleClick)
        EventBus.on('mobilenav:close', this.handleNavClose)
    }

    destroy() {
        EventBus.off('mobilenav:close', this.handleNavClose)
    }

    handleClick(event) {
        event.preventDefault()
        EventBus.emit('mobilenav:close')
        this.handleNavClose()
    }

    handleNavClose = () => {
        document.body.classList.remove(STATES.MENU_OPEN)
        document.querySelector('.Nav').classList.remove(STATES.ACTIVE)
    }

}
